import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = { class: "offcanvas-footer" }

import { computed, onMounted, ref } from "vue";
import { toTypedSchema } from "@vee-validate/zod";
import { useForm } from "vee-validate";
import { useVeeField } from "@/composables/useVeeField";
import { profileAboutSchema } from "@/schemas/profile";
import { useSessionStore } from "@/store/useSessionStore";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { useUpdateUser } from "@/composables/useAuth";


export default /*#__PURE__*/_defineComponent({
  __name: 'About',
  setup(__props) {

const sessionStore = useSessionStore();
const session = computed(() => sessionStore.session);
const submitting = ref(false);

const { handleSubmit, meta, resetForm } = useForm({
  validationSchema: toTypedSchema(profileAboutSchema),
  initialValues: {
    education: "",
    years_exp: "",
    crp: "",
    epsi: "",
    bio: "",
  },
});

const educationModel = useVeeField("education");
const yearsExpModel = useVeeField("years_exp");
const crpModel = useVeeField("crp");
const epsiModel = useVeeField("epsi");
const bioModel = useVeeField("bio");

onMounted(() => {
  if (session.value) {
    resetForm({
      values: {
        education: session.value.education ?? "",
        years_exp: String(session.value.years_exp ?? ""),
        crp: session.value.crp ?? "",
        epsi: (session.value as any).epsi ?? "",
        bio: session.value.bio ?? "",
      },
    });
  }
});

const { mutateAsync: updateUser } = useUpdateUser();

const submit = handleSubmit(async (values) => {
  try {
    submitting.value = true;
    await updateUser({ id: session.value!.id, ...values });
    EventBus.$emit(EventBusNames.SHOW_TOAST, {
      title: "Alterações feitas",
      msg: "Suas informações foram salvas",
    });
  } catch (error) {
    console.error(error);
  } finally {
    submitting.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_TextAreaInput = _resolveComponent("TextAreaInput")!
  const _component_FormButton = _resolveComponent("FormButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_TextInput, {
        required: "",
        label: "Formação",
        model: _unref(educationModel),
        placeholder: "Qual sua formação?"
      }, null, 8, ["model"]),
      _createVNode(_component_TextInput, {
        required: "",
        label: "Anos de experiência",
        model: _unref(yearsExpModel),
        placeholder: "Você trabalha há quantos anos na área?"
      }, null, 8, ["model"]),
      _createVNode(_component_TextInput, {
        required: "",
        label: "CRP",
        model: _unref(crpModel),
        mask: "##/######",
        placeholder: "00/000000"
      }, null, 8, ["model"]),
      _createVNode(_component_TextInput, {
        label: "E-psi",
        model: _unref(epsiModel),
        placeholder: "Qual número do seu E-psi?"
      }, null, 8, ["model"]),
      _createVNode(_component_TextAreaInput, {
        required: "",
        label: "Resumo do currículo",
        model: _unref(bioModel),
        placeholder: "Descreva um pouco sobre sua experiencia"
      }, null, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FormButton, {
        marginVertical: false,
        label: "Concluir",
        loading: submitting.value,
        onOnClick: _unref(submit),
        disabled: !_unref(meta).valid
      }, null, 8, ["loading", "onOnClick", "disabled"])
    ])
  ], 64))
}
}

})